import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Redirect, Route} from 'react-router-dom'
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

@withRouter
@connect(state => ({isAuthenticated: state.auth.isAuthenticated}))
export default class PrivateRoute extends Component {
    static propTypes = {
        isAuthenticated: PropTypes.bool,
        render: PropTypes.func,
        component: PropTypes.func,
    };

    render() {
        const {component: Comp, isAuthenticated, ...rest} = this.props;
        if (this.props.render) {
            return <Route {...rest}/>;
        }

        return (<Route {...rest} render={props => (
            isAuthenticated ? (
                <Comp {...props}/>
            ) : (
                <Redirect to={{
                    pathname: '/login',
                    state: {savedLocation: props.location}
                }}/>
            )
        )}/>);
    }
}



// WEBPACK FOOTER //
// ./src/containers/PrivateRoute.js